import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import './Pnl.scss'

type PnlProps = {
  value?: number | string
  isRate?: boolean
}

export const Pnl = defineComponent<PnlProps>({
  name: 'Pnl',
  props: DefineComponentProps<PnlProps>(['value', 'isRate']),
  setup(props, { slots }) {
    const newValue = computed(() => {
      if (!props.value) return '--'
      const prefix = props.value?.isGreaterThan(0) ? '+' : ''

      if (props.isRate) {
        if (props.value?.isEqualTo(0)) {
          return '0.00%'
        }
        return `${prefix}${props.value?.decimalPadZero(2)}%`
      }
      if (props.value?.isEqualTo(0)) {
        return '0.00'
      }
      return `${prefix}${props.value?.removeTrailingZero.formatNumberWithCommas().decimalPadZero(2)}`
    })
    return () => (
      <div
        class={classNames('pnl', {
          up: props.value?.isGreaterThan(0),
          down: props.value?.isLessThan(0),
          zero: props.value?.isEqualTo(0),
        })}
      >
        {newValue.value}&nbsp;
        {slots.default?.()}
      </div>
    )
  },
})
